import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Observable} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {LoginAction} from '../../store/authentication-actions';
import {AppState} from '../../../app.store';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginGroup: FormGroup;

  loginError$: Observable<string>;
  @Output() forgotPassword: EventEmitter<void> = new EventEmitter();
  @Output() registerNewAccount: EventEmitter<void> = new EventEmitter();
  isLoading$: Observable<number>;
  constructor(private  store: Store<any>) {
  }

  ngOnInit() {
    this.createFormGroup();
    this.isLoading$ =
      this.store.pipe(
        select((state: AppState) => state.loading.active)
      );
    this.loginError$  = this.store.select(state => state.auth.loginError);
    this.loginGroup.statusChanges.subscribe((sttus) => console.log());
  }

  private createFormGroup() {
    this.loginGroup = new FormGroup({
      email: new FormControl('', [Validators.email]),
      password: new FormControl('', [Validators.required])
    });
  }


  login() {
    if (this.loginGroup.invalid) {
      return;
    }

    this.store.dispatch( new LoginAction({
      username: this.loginGroup.get('email').value,
      password: this.loginGroup.get('password').value
    }));

  }

  emailRequired(): boolean {
    return this.loginGroup.controls.email.touched && this.loginGroup.controls.email.dirty
      && this.loginGroup.controls.email.errors && this.loginGroup.controls.email.errors.required;
  }


  emailIsEmail(): boolean {
    return this.loginGroup.controls.email.touched && this.loginGroup.controls.email.dirty
      && this.loginGroup.controls.email.errors && this.loginGroup.controls.email.errors.email;
  }
  forgotPasswordClicked() {
    this.forgotPassword.emit();
  }

  registerNewAccountClicked() {
    this.registerNewAccount.emit();
  }
}
